module.exports = __webpack_public_path__ + "img/8_002.ad6eb22d.webp";